import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import "./VideoModal.scss";
import { FormattedMessage, useIntl } from "react-intl";

const VideoModal = (props) => {
  const intl = useIntl();
  const [loadUrl, setLoadUrl] = useState(false);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    //Event handler looks for button click
    document.addEventListener("click", handleButtonClick);

    return () => {
      document.removeEventListener("click", handleButtonClick);
    };
  }, []);

  const handleButtonClick = (event) => {
    var selected = event.target.getAttribute("datapropmodal");
    if (selected == props.blok.modal_id && selected && props.blok.modal_id) {
      handleShow();
    }
  };

  return (
    // <Modal
    //   className="video-modal"
    //   {...props}
    //   size="lg"
    //   aria-labelledby="contained-modal-title-vcenter"
    //   centered
    //   show={show}
    //   onHide={handleClose}
    // >
      // <Modal.Header>
      //   <button
      //     type="button"
      //     className="btn-close"
      //     aria-label="Close"
      //     onClick={handleClose}
      //   >
      //     {intl.messages["widget.modal.exit"]}
      //   </button>
      // </Modal.Header>
      <Modal.Body>
        <div className="video-wrapper">
          <iframe
            width="920"
            height="518"
            src={props.blok.video_url.url}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </Modal.Body>
    // </Modal>
  );
};

export default VideoModal;
